module.exports = __webpack_public_path__ + "img/PGR_A05_back_cross_en.84676a3a.png";